import './global.css';


export const applyGlobalStyles = () => {
  // call this method to prevent this module from being tree-shaken
  console.log('Global styles applied');
};
